module.exports = __webpack_public_path__ + "static/media/unity.2cffd271.svg";